import { GDA_CONTINUOUS, GDA_DISCRETE } from "./types";

const reconcileAuctionResponse = (auction, auctionState) => {
  const normalized = Object.assign({}, auctionState, {
    id: auction.auction_external_id,
    stateExternalId: auctionState.external_id,
    kind: auction.kind,
    products: auction.products,
  });

  switch (normalized.kind) {
    case GDA_CONTINUOUS.KIND: {
      return Object.assign({}, normalized, {
        last_epoch: new Date(auctionState.last_epoch + "Z").getTime() / 1000,
      });
    }
    case GDA_DISCRETE.KIND: {
      return Object.assign({}, normalized, {
        start_epoch: new Date(auctionState.start_epoch + "Z").getTime() / 1000,
      });
    }
    default: {
      return {};
    }
  }
};

export const reconcileAuctionsResponse = (auctions) => {
  return auctions.map((auction) =>
    reconcileAuctionResponse(auction, { ...JSON.parse(auction.auction_state) })
  );
};

export const reconcileRealtimeUpdateIntoAuction = (auction, realtimeUpdate) => {
  /*
    realtimeUpdate: {
      "schema": "public",
      "table": "gda_discrete_state",
      "commit_timestamp": "2023-01-17T09:18:57Z",
      "eventType": "UPDATE",
      "new": {
        "auction_id": 9,
        "decay_rate": 0.001,
        "external_id": "f02e6ac2-139f-4540-8c10-cd182df80452",
        "id": 8,
        "quantity": 1,
        "scale_factor": 1.01,
        "sold": 7,
        "start_epoch": "2023-01-12T10:14:27",
        "starting_price": 100
      },
      "old": {
        "id": 8
      },
      "errors": null
    }
  */

  return reconcileAuctionResponse(
    Object.assign({}, auction),
    realtimeUpdate.new
  );
};
